module.exports = __webpack_public_path__ + "static/media/eye.73ef8507.svg";